import * as DemoRequestService from '../services/demo-request-service';

export function resetReducer() {
  return function (dispatch) {
    dispatch(reset());
  };
}

export function demoRequest(user) {
  return async function (dispatch) {
    dispatch(process());
    try {
      const response = await DemoRequestService.performDemoRequest(user);
      return dispatch(success('DEMO_REQUEST_SUCCESS', response.data));
    } catch (err) {
      return dispatch(error('DEMO_REQUEST_ERROR', err));
    }
  };
}

function reset() {
  return {
    type: 'DEMO_REQUEST_STATE'
  };
}

function process() {
  return {
    type: 'PROCESSING_DEMO_REQUEST',
  };
}

function success(type, data) {
  return {
    type: type,
    payload: data,
  };
}
function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}